/** Slice I — verify / parameter document labels (max-lines split). */

export const COMMON_UI_I18N_PART2_SLICE_I = {
	verifyPages: {
		verifyTitle: "Vérification",
		verifyDocumentTitle: "Vérification de document",
		/** Libellé du champ fichier (zone glisser-déposer) — accessibilité */
		verifyDocumentFileInputLabel: "Choisir un fichier à vérifier (PDF, JPG, PNG ou document Word)",
	},
	parameterDocuments: {
		documentExistingLabel: "Document existant",
		createDocumentLabel: "Créer un document",
	},
} as const;
